/** Strip markdown code fences the model may emit despite instructions (handles partial streams). */
export function stripFences(s: string): string {
  const closed = s.match(/```(?:tsx?|jsx?|react)?\s*\n([\s\S]*?)```/);
  if (closed) return closed[1].trim();
  return s.replace(/^```(?:tsx?|jsx?|react)?\s*\n?/, '').replace(/```\s*$/, '');
}

export function countLines(code: string): number {
  return code === '' ? 0 : code.split('\n').length;
}
